// extracted by mini-css-extract-plugin
export var modal = "_dz-0";